import addDiscount from './addDiscount';
export default addDiscount;